import React, { useState } from 'react';
import { Link, useParams, useNavigate } from 'react-router-dom';
import { reinitialiserMotDePasse } from '../services/api';

const ReinitialiserMotDePasse = () => {
  const { token } = useParams();
  const navigate = useNavigate();
  const [mdp, setMdp] = useState('');
  const [confirmation, setConfirmation] = useState('');
  const [erreur, setErreur] = useState('');
  const [succes, setSucces] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setErreur('');
    setSucces('');

    if (mdp.length < 6) {
      setErreur('Le mot de passe doit contenir au moins 6 caractères.');
      return;
    }
    if (mdp !== confirmation) {
      setErreur('Les deux mots de passe ne correspondent pas.');
      return;
    }

    setLoading(true);
    try {
      const res = await reinitialiserMotDePasse(token, mdp);
      setSucces(res.data.message);
      setTimeout(() => navigate('/connexion'), 2500);
    } catch (err) {
      setErreur(err.response?.data?.message || 'Erreur lors de la réinitialisation');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center px-4" style={{ background: '#0A0A0A' }}>
      <div className="w-full max-w-md">

        <div className="text-center mb-6">
          <Link to="/" className="inline-block">
            <img src="/logo.jpg" alt="JJ Cars" className="h-12 w-auto object-contain mx-auto" />
          </Link>
        </div>

        <h1 className="text-white text-2xl font-black mb-1">Nouveau mot de passe</h1>
        <p className="text-gray-500 mb-5 text-sm">
          Choisissez un nouveau mot de passe pour votre compte JJ Cars.
        </p>

        {erreur && (
          <div className="bg-red-900 bg-opacity-30 border border-red-500 text-red-400 p-2.5 rounded-xl mb-3 text-xs">
            {erreur}
          </div>
        )}
        {succes && (
          <div className="bg-green-900 bg-opacity-30 border border-green-500 text-green-400 p-3 rounded-xl mb-3 text-sm">
            {succes}
            <p className="text-xs text-green-300 mt-1">Redirection vers la connexion…</p>
          </div>
        )}

        {!succes && (
          <form onSubmit={handleSubmit} className="space-y-3">
            <div>
              <label className="block text-xs font-semibold text-gray-400 mb-1">Nouveau mot de passe</label>
              <input
                type="password"
                required
                value={mdp}
                onChange={(e) => setMdp(e.target.value)}
                style={{ background: '#1a1a1a', border: '1px solid #333', color: 'white' }}
                className="w-full px-3 py-2 rounded-xl text-sm focus:outline-none focus:border-yellow-400 transition"
                placeholder="••••••••"
              />
            </div>

            <div>
              <label className="block text-xs font-semibold text-gray-400 mb-1">Confirmation</label>
              <input
                type="password"
                required
                value={confirmation}
                onChange={(e) => setConfirmation(e.target.value)}
                style={{ background: '#1a1a1a', border: '1px solid #333', color: 'white' }}
                className="w-full px-3 py-2 rounded-xl text-sm focus:outline-none focus:border-yellow-400 transition"
                placeholder="••••••••"
              />
            </div>

            <button
              type="submit"
              disabled={loading}
              style={{ background: '#F5A623' }}
              className="w-full text-black py-2 rounded-xl font-black text-sm hover:opacity-90 transition disabled:opacity-50"
            >
              {loading ? 'Mise à jour...' : 'Valider le nouveau mot de passe'}
            </button>
          </form>
        )}

        <p className="text-center text-gray-500 mt-5 text-sm">
          <Link to="/connexion" style={{ color: '#F5A623' }} className="font-bold hover:opacity-80">
            ← Retour à la connexion
          </Link>
        </p>
      </div>
    </div>
  );
};

export default ReinitialiserMotDePasse;
